import React from 'react';
import styled from 'styled-components';

// Create a Title component that'll render an <div> tag with some styles
const Title = styled.div`
  font-size: 16px;
  text-align: center;
  color: #888888;
  padding: 5px;
  letter-spacing: 0.025em;
  font-weight: 450;
`;

// Create a Wrapper component that'll render a <section> tag with some styles
const Wrapper = styled.section`
  background: white;
  border-bottom: 1px solid #D5D5D5;
  line-height: 1.5;
`;

export function Disclaimer({ phone }) {
  return (
    <Wrapper>
      <Title>
        <a
          style={{color: '#888888'}}
          href={`tel: ${phone}`}
          target='_blank'
          rel='noreferrer'
        >
          Call
          {' '}
          { phone }
          {' '}
          For Quick Quotes
        </a>
      </Title>
    </Wrapper>
  );
}
